(function (ng, app) {

    app.controller("RedeemMarketingDollars2Controller", RedeemMarketingDollars2Controller);
    RedeemMarketingDollars2Controller.$inject = ["_", "featureToggleService", "figToaster", "$mdDialog", "moment", "pointAdjustmentApi"];
    function RedeemMarketingDollars2Controller(_, featureToggleService, figToaster, $mdDialog, moment, pointAdjustmentApi) {
        var $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                submitting: false,
                isUploading: false
            },
            activeStep: 0,
            form: {
                FileIDs: [],
                MarketingDollarCategoryIDs: [],
                MarketingDollarRequestPaymentTypeIDs: [],
                PhysicalAddress: { Line1: "", City: "", StateCode: "", PostalCode: "" },
                RequestedOn: moment().format('L'),
                OtherPaymentNotes: ''
            },
            paymentTypes: [
                { Id: 5, Title: 'ACH (Direct Deposit)' },
                { Id: 1, Title: 'Check' },
                { Id: 2005, Title: 'Other' }
            ],
            purchaseCategories: [
                { Id: 19, Title: 'Memberships/Subscriptions' },
                { Id: 20, Title: 'Websites' },
                { Id: 24, Title: 'Miscellaneous' },
                { Id: 1017, Title: 'Travel' },
                { Id: 2017, Title: 'Branding' },
                { Id: 2018, Title: 'Print Advertising' },
                { Id: 2019, Title: 'TV' },
                { Id: 2020, Title: 'Books' },
                { Id: 2021, Title: 'Radio' },
                { Id: 2022, Title: 'PR' },
                { Id: 2023, Title: 'Video' },
                { Id: 2024, Title: 'Lead Purchase' },
                { Id: 2025, Title: 'Seminar Mailers' },
                { Id: 2026, Title: 'Seminar Dinners' },
                { Id: 2027, Title: 'College Courses' },
                { Id: 2028, Title: 'Social Media' },
                { Id: 2029, Title: 'Email Marketing' },
                { Id: 2030, Title: 'Educational Client Events' },
                { Id: 2031, Title: 'Social Client Events' },
                { Id: 2032, Title: 'Training' }
            ],
            State: {
                StateID: null,
                State: ''
            },
            states: [{ StateID: 2, State: "AL", StateName: "Alabama", IsVisible: true }, { StateID: 1, State: "AK", StateName: "Alaska", IsVisible: true }, { StateID: 4, State: "AZ", StateName: "Arizona", IsVisible: true }, { StateID: 3, State: "AR", StateName: "Arkansas", IsVisible: true }, { StateID: 5, State: "CA", StateName: "California", IsVisible: true }, { StateID: 6, State: "CO", StateName: "Colorado", IsVisible: true }, { StateID: 7, State: "CT", StateName: "Connecticut", IsVisible: true }, { StateID: 9, State: "DE", StateName: "Delaware", IsVisible: true }, { StateID: 8, State: "DC", StateName: "District Of Columbia", IsVisible: true }, { StateID: 10, State: "FL", StateName: "Florida", IsVisible: true }, { StateID: 11, State: "GA", StateName: "Georgia", IsVisible: true }, { StateID: 12, State: "HI", StateName: "Hawaii", IsVisible: true }, { StateID: 14, State: "ID", StateName: "Idaho", IsVisible: true }, { StateID: 15, State: "IL", StateName: "Illinois", IsVisible: true }, { StateID: 16, State: "IN", StateName: "Indiana", IsVisible: true }, { StateID: 13, State: "IA", StateName: "Iowa", IsVisible: true }, { StateID: 17, State: "KS", StateName: "Kansas", IsVisible: true }, { StateID: 18, State: "KY", StateName: "Kentucky", IsVisible: true }, { StateID: 19, State: "LA", StateName: "Louisiana", IsVisible: true }, { StateID: 22, State: "ME", StateName: "Maine", IsVisible: true }, { StateID: 21, State: "MD", StateName: "Maryland", IsVisible: true }, { StateID: 20, State: "MA", StateName: "Massachusetts", IsVisible: true }, { StateID: 23, State: "MI", StateName: "Michigan", IsVisible: true }, { StateID: 24, State: "MN", StateName: "Minnesota", IsVisible: true }, { StateID: 26, State: "MS", StateName: "Mississippi", IsVisible: true }, { StateID: 25, State: "MO", StateName: "Missouri", IsVisible: true }, { StateID: 27, State: "MT", StateName: "Montana", IsVisible: true }, { StateID: 30, State: "NE", StateName: "Nebraska", IsVisible: true }, { StateID: 34, State: "NV", StateName: "Nevada", IsVisible: true }, { StateID: 31, State: "NH", StateName: "New Hampshire", IsVisible: true }, { StateID: 32, State: "NJ", StateName: "New Jersey", IsVisible: true }, { StateID: 33, State: "NM", StateName: "New Mexico", IsVisible: true }, { StateID: 35, State: "NY", StateName: "New York", IsVisible: true }, { StateID: 28, State: "NC", StateName: "North Carolina", IsVisible: true }, { StateID: 29, State: "ND", StateName: "North Dakota", IsVisible: true }, { StateID: 36, State: "OH", StateName: "Ohio", IsVisible: true }, { StateID: 37, State: "OK", StateName: "Oklahoma", IsVisible: true }, { StateID: 38, State: "OR", StateName: "Oregon", IsVisible: true }, { StateID: 39, State: "PA", StateName: "Pennsylvania", IsVisible: true }, { StateID: 40, State: "PR", StateName: "Puerto Rico", IsVisible: true }, { StateID: 41, State: "RI", StateName: "Rhode Island", IsVisible: true }, { StateID: 42, State: "SC", StateName: "South Carolina", IsVisible: true }, { StateID: 43, State: "SD", StateName: "South Dakota", IsVisible: true }, { StateID: 44, State: "TN", StateName: "Tennessee", IsVisible: true }, { StateID: 45, State: "TX", StateName: "Texas", IsVisible: true }, { StateID: 46, State: "UT", StateName: "Utah", IsVisible: true }, { StateID: 48, State: "VT", StateName: "Vermont", IsVisible: true }, { StateID: 54, State: "VI", StateName: "Virgin Islands", IsVisible: true }, { StateID: 47, State: "VA", StateName: "Virginia", IsVisible: true }, { StateID: 49, State: "WA", StateName: "Washington", IsVisible: true }, { StateID: 51, State: "WV", StateName: "West Virginia", IsVisible: true }, { StateID: 50, State: "WI", StateName: "Wisconsin", IsVisible: true }, { StateID: 52, State: "WY", StateName: "Wyoming", IsVisible: true }, { StateID: 53, State: "XX", StateName: "XX", IsVisible: true }],
            uploadingFiles: [],
            vendors: [
                { Id: 1, Title: 'Plum' },
                { Id: 2, Title: 'Whiteglove Workshops' },
                { Id: 3, Title: 'Thomas Gold Solutions' },
                { Id: 4, Title: 'Windows of Opportunity' },
                { Id: 5, Title: 'Evolution Selling' },
                { Id: 6, Title: 'Sales Surge Copywriting' },
                { Id: 7, Title: 'RME (Leading Response)' },
                { Id: 8, Title: 'Seminar Innovations' },
                { Id: 9, Title: 'SlipStream' },
                { Id: 10, Title: 'NTA Digital' },
                { Id: 11, Title: 'The Advisor Suite' }
            ],
            submitted: false,
            closeDialog: closeDialog,
            createAdjustmentRequest: createAdjustmentRequest,
            removeFile: removeFile,
            uploadFiles: uploadFiles
        });

        function createAdjustmentRequest() {
            $ctrl.ui.submitting = true;
            $ctrl.form.MarketingDollarAmount = $ctrl.form.InvoiceAmount;
            $ctrl.form.MarketingDollarCategoryIDs.push($ctrl.form.MarketingDollarCategoryID);
            $ctrl.form.MarketingDollarRequestPaymentTypeID = $ctrl.MarketingDollarRequestPaymentType.Id;
            $ctrl.form.MarketingDollarRequestPaymentTypeIDs.push($ctrl.form.MarketingDollarRequestPaymentTypeID);
            $ctrl.form.Notes = 'Portal Request Notes: ' + (!!$ctrl.form.Notes ? $ctrl.form.Notes : 'No notes.');

            //for Other payment type, concat payment notes to form.Notes
            if ($ctrl.MarketingDollarRequestPaymentType.Id === 2005) {
                $ctrl.form.Notes = $ctrl.form.Notes + '\n' + 'Payment Type Note: ' + $ctrl.form.OtherPaymentNotes;
            }

            $ctrl.form.PhysicalAddress.StateID = !!$ctrl.State.StateID ? $ctrl.State.StateID : null;
            $ctrl.form.PhysicalAddress.StateCode = !!$ctrl.State.State ? $ctrl.State.State : '';
            $ctrl.form.RequestedByEmailAddress = null;

            return pointAdjustmentApi.submitPointAdjustmentForm($ctrl.form)
                .then(function (response) {
                    var _requestId = response;
                    if (_requestId !== null) {
                        $ctrl.submitted = true;
                        return _sendFilesToArcRequest(_requestId).then(function () {
                            $ctrl.activeStep = 5;
                            return _sendEmail(_requestId, $ctrl.form.SendEmailTo);
                        });
                    }

                })
                // since all the previous chains returns a response from the server, this will catch the response if the promise is rejected & attach it to the error email.
                // this makes it easier than having to throw catches on every call
                .catch(function (error) {
                    $ctrl.activeStep = 1;
                    var message = "There was a problem creating your request. Please try again shortly.",
                        toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    $ctrl.ui.submitting = false;
                });
        }

        function _sendFilesToArcRequest(requestId) {
            var formData = new FormData();
            $ctrl.ui.isUploading = true;
            $ctrl.uploadingFiles.forEach(function (file) {
                formData.append(file.notes, file, file.name);
            });

            if (!!requestId) {
                return pointAdjustmentApi.uploadToRequest(requestId, formData);
            }
        }

        function uploadFiles(files, invalidFiles) {
            if ($ctrl.uploadForm.$invalid) {
                var invalidFileNames = _.map(invalidFiles,
                    function (file) {
                        return file.name;
                    }).join(", ");
                var toastClass = 'is-error';
                var toastMessage;
                //Added custom system feedback based on form validation
                if ($ctrl.uploadForm.$error.maxSize) {
                    toastMessage = 'File size cannot exceed 30MB per file. Please upload a different file.';
                }
                if ($ctrl.uploadForm.$error.pattern) {
                    toastMessage = 'File type is not supported. Please upload a different file.';
                }
                figToaster.showSimple(invalidFileNames + ' not uploaded. ' + toastMessage, "top", toastClass);
            }

            if (files.length > 0 && $ctrl.uploadForm.$valid) {
                //Add each valid file to filesList for uploading onSubmit
                files.forEach(function (file) {
                    $ctrl.uploadingFiles.push(file);
                });
            }
        }

        function removeFile(file) {
            //remove files from upload list before converting to formData
            $ctrl.uploadingFiles = _.remove($ctrl.uploadingFiles, function (activeFile) {
                return activeFile !== file;
            });
        }

        function _sendEmail(requestId, sendToEmail) {
            var emailData = {
                firstName: !!$ctrl.onBehalfOfUser ? $ctrl.onBehalfOfUser.FirstName : $ctrl.user.FirstName,
                lastName: !!$ctrl.onBehalfOfUser ? $ctrl.onBehalfOfUser.LastName : $ctrl.user.LastName,
                sendToEmail: sendToEmail
            };
            return pointAdjustmentApi.sendPointAdjustmentEmails(requestId, emailData);
        }

        function closeDialog($event) {
            $mdDialog.hide($event);
        }

        $ctrl.$onInit = function () {
            $ctrl.toggleFeature = featureToggleService.checkEnv();
            $ctrl.form.SendEmailTo = $ctrl.toggleFeature === 'prod'
                ? !!$ctrl.onBehalfOfUser
                    ? $ctrl.onBehalfOfUser.Email
                    : $ctrl.user.Email
                : 'devteam@figmarketing.com';
        };
    }

})(window.angular, window.app); //jshint ignore:line